import React from 'react';
import PropTypes from 'prop-types';

export const BestWorkPlacesLayout = ({ year, children }) => {
  return (<div id={`BestWorkPlacesPage__${year}`}>{children}</div>)
};

BestWorkPlacesLayout.propTypes = {
  year: PropTypes.string,
  children: PropTypes.any
}
